// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__VBcTK","modalFooterButton":"ModalNotes_modalFooterButton__25c9Y"};